﻿import LandingPage from "./Registration/LandingPage.svelte";
import PersonalDetails from "./Registration/PersonalDetails.svelte";
import ActionSpecific from "./Registration/ActionSpecific.svelte";

const confirmationPages = [
	{
		pageIndex: 0,
		component: LandingPage,
		routeId: "/Registration",
		showInConfirmation: true,
		confirmationHeading: null
	},
	{
		pageIndex: 1,
		component: PersonalDetails,
		routeId: "/Registration/PersonalDetails",
		showInConfirmation: true,
		confirmationHeading: "Your details"
	},
	{
		pageIndex: 2,
		component: ActionSpecific,
		routeId: "/Registration/ActionSpecific",
		showInConfirmation: true,
		confirmationHeading: "Action Specific"
	}
];

export default confirmationPages;
